;
(function ( $ ) {
    var geo = {
      getAddressComponent: function(data, type, key) {
        if ( data && data.address_components ) {
          for ( var i = 0; i < data.address_components.length; i++ ) {
            var component = data.address_components[i];
            if ( component['types'] ) {
              for ( var j = 0; j < component['types'].length; j++ ) {
                if (component['types'][j] === type ) {
                  return component[key];
                }
              }
            }
          }
        }
        return null;
      },

      getBestResult: function(data, postCode, countryFilter ) {
        if ( data.length > 0 ) {
          for ( var i = 0; i < data.length; i++ ) {
            var result = data[i];
            var country = this.getAddressComponent(result, "country", "short_name");
            if ( !countryFilter || country === countryFilter ) {
              var geom = result.geometry;
              var city = this.getAddressComponent(result, 'locality', 'long_name');
              if ( !city || city.length == 0) {
                city = this.getAddressComponent(result, 'administrative_area_level_3', 'long_name');
              }
              if ( !city || city.length == 0) {
                city = this.getAddressComponent(result, 'neighborhood', 'long_name');
              }
              if ( geom.location && geom.location.lat && geom.location.lng ) {
                return {
                  postCode: postCode,
                  lat: geom.location.lat,
                  lng: geom.location.lng,
                  street: this.getAddressComponent(result, "route", "long_name"),
                  city: city,
                  region: this.getAddressComponent(result, 'administrative_area_level_2', 'long_name'),
                  state: this.getAddressComponent(result, "administrative_area_level_1", "short_name"),
                  country: country
                };
              }
            }
          }
        }
        return null;
      },

      handleResults: function(data, postCode, countryFilter) {
        var result = this.getBestResult(data, postCode, countryFilter);
        if ( result ) {
          $.ajax({
            url: '/api/users/gpsfill',
            type: 'post',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (data) {
            },
            data: JSON.stringify(result)
          });
        }
      },

      getPostalCode: function(postCode) {
        var that = this;
        var deferred = $.Deferred();
        // Receiving object from geo.js controller
        var country = '';
        if (postCode.match(/[a-zA-Z]/i)) {
          // alphabet letters found
          country = 'CA';
        } else {
          country = 'US';
        }

        var url = 'https://maps.googleapis.com/maps/api/geocode/json?address=';
        if ( country == 'US' ) {
          url += ('00000'+postCode.trim()).slice(-5);
        } else {
          url += postCode.trim();
        }

        $.get(url)
          .done(function(geoData) {
            var entity = {
              postCode: postCode,
              country: country
            };

            if ( geoData.results ) {
              entity = that.getBestResult(geoData.results, postCode, country);
            }
            deferred.resolve({
              geoData: geoData,
              country: country,
              entity: entity
            });
          });
        return deferred.promise();
      },

      contributeOne: function(postCode) {
        var that = this;
        that.getPostalCode(postCode).then(function(data){
          var geoData = data.geoData;
          if ( geoData.results ) {
            that.handleResults( geoData.results, postCode, data.country );
          }
        });
      },

      // Hydrate our database with geometric information about postal codes
      contribute: function() {
        var that = this;
        $.getJSON('/api/users/gpsfill', function(data){
            var processNext = function(idx) {
              if ( idx < data.rows.length ) {
                var postCode = data.rows[idx].postCode;
                that.getPostalCode(postCode).then(function(data){
                  var geoData = data.geoData;
                  if ( geoData.results ) {
                    that.handleResults( geoData.results, postCode, data.country );
                  }
                  setTimeout(function() {
                    processNext(idx+1);
                  }, 15000);
                });
              }
            };
            processNext(0);
          });
      }
    };

    $.geo = function( action ) {
        var args = Array.prototype.slice.call(arguments, 1);
        switch ( action ) {
            case 'getPostalCode':
                return geo.getPostalCode(args[0]);
            case 'contribute':
              return geo.contribute();
            case 'contributeOne':
              return geo.contributeOne(args[0]);
        }
    };
})( jQuery );